module.exports = __webpack_public_path__ + "static/media/card_oferta_progressiva2.83776fbe.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/loyal-design-system/assets/images/card_oferta_progressiva2.png
// module id = 1971
// module chunks = 12